"use client";

import Link from "next/link";
import { Sparkles, UserRound } from "lucide-react";
import type { DefaultAvatarGender } from "@/data/types/classroom";

interface ClassroomAvatarSetupGateProps {
  onCreateAvatar: () => void;
  onContinueDefault: (gender: DefaultAvatarGender) => void;
  creating?: boolean;
  isLoggedIn: boolean;
  selectedGender: DefaultAvatarGender;
  onGenderChange: (gender: DefaultAvatarGender) => void;
}

export default function ClassroomAvatarSetupGate({
  onCreateAvatar,
  onContinueDefault,
  creating = false,
  isLoggedIn,
  selectedGender,
  onGenderChange,
}: ClassroomAvatarSetupGateProps) {
  return (
    <div className="flex h-full items-center justify-center bg-[#09090d] p-4">
      <div className="w-full max-w-lg rounded-2xl border border-violet-500/25 bg-gray-950 p-6 sm:p-8 shadow-2xl">
        <div className="flex items-center gap-2 text-violet-300">
          <Sparkles className="h-5 w-5" />
          <span className="text-sm font-semibold uppercase tracking-wider">
            1:1 체험 준비
          </span>
        </div>
        <h1 className="mt-4 text-2xl font-semibold text-white">
          내 캐릭터로 체험해 볼까요?
        </h1>

        <div className="mt-5">
          <p className="text-xs text-white/45 mb-2">기본 캐릭터 성별</p>
          <div className="grid grid-cols-2 gap-2">
            <button
              type="button"
              onClick={() => onGenderChange("female")}
              className={`rounded-xl border px-4 py-3 text-sm font-medium transition ${
                selectedGender === "female"
                  ? "border-violet-400 bg-violet-500/20 text-white"
                  : "border-white/10 text-white/65 hover:border-white/20"
              }`}
            >
              여성 캐릭터
            </button>
            <button
              type="button"
              onClick={() => onGenderChange("male")}
              className={`rounded-xl border px-4 py-3 text-sm font-medium transition ${
                selectedGender === "male"
                  ? "border-sky-400 bg-sky-500/20 text-white"
                  : "border-white/10 text-white/65 hover:border-white/20"
              }`}
            >
              남성 캐릭터
            </button>
          </div>
        </div>

        <div className="mt-6 space-y-3">
          {isLoggedIn ? (
            <button
              type="button"
              onClick={onCreateAvatar}
              disabled={creating}
              className="flex w-full items-center justify-center gap-2 rounded-full bg-violet-500 px-6 py-3.5 font-semibold text-white transition hover:bg-violet-400 disabled:opacity-60"
            >
              <UserRound className="h-4 w-4" />
              {creating ? "저장 중..." : "내 캐릭터 만들기"}
            </button>
          ) : (
            <Link href="/auth/login?redirect=/realtime-feedback/demo">
              <button
                type="button"
                className="flex w-full items-center justify-center gap-2 rounded-full bg-violet-500 px-6 py-3.5 font-semibold text-white transition hover:bg-violet-400"
              >
                <UserRound className="h-4 w-4" />
                로그인하고 캐릭터 만들기
              </button>
            </Link>
          )}

          <button
            type="button"
            onClick={() => onContinueDefault(selectedGender)}
            className="w-full rounded-full border border-white/15 px-6 py-3.5 text-sm font-medium text-white/75 transition hover:bg-white/5"
          >
            기본 캐릭터로 바로 체험
          </button>
        </div>

        <p className="mt-5 text-center text-xs text-white/40">
          공식 프로 Tony가 녹음실에서 직접 안내해 드려요.
        </p>
      </div>
    </div>
  );
}
